import {
  type ResourceOptionsProps,
  ResourceOptions as SharedResourceOptions,
  SortDropdown as SharedSortDropdown,
  type SortDropdownProps,
} from '@ondit/ui'
import { useT } from '~/core/i18n'

export type {
  ColumnOption,
  FilterConfig,
  FilterTag,
  SearchConfig,
  SearchTag,
  SortConfig,
} from '@ondit/ui'
export { FILTER_SECTION_LABEL_CLASS } from '@ondit/ui'

export function ResourceOptions(props: ResourceOptionsProps) {
  const t = useT()
  return <SharedResourceOptions {...props} translate={t} />
}

export function SortDropdown(props: SortDropdownProps) {
  const t = useT()
  return <SharedSortDropdown {...props} translate={t} />
}
